/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import FlightIcon from "@mui/icons-material/Flight";
import { Typography, useTheme } from "@mui/material";
import { CellProps } from "./MovementCell";

interface FlightCellProps extends CellProps {
  flightName: string;
  departureLocation: string;
  arrivalLocation: string;
}

const FlightCell = (props: FlightCellProps) => {
  const theme = useTheme();
  return (
    <div
      style={{
        display: "flex",
        padding: 5,
        color: theme.palette.cells.flight1.text,
        background: theme.palette.cells.flight1.background,
        borderRadius: 5,
        flexDirection: "column",
        alignItems: "start",
        width: "100%",
        minHeight: 50,
      }}
    >
      <div
        style={{
          display: "flex",
        }}
      >
        <FlightIcon fontSize="small" color="inherit" />
        <Typography variant="caption" maxWidth={50} noWrap={true}>
          {props.flightName}
        </Typography>
      </div>
      <div>
        <Typography
          variant="caption"
          maxWidth={50}
          noWrap={true}
          color="inherit"
        >
          {props.departureLocation} &rarr; {props.arrivalLocation}{" "}
        </Typography>
      </div>
    </div>
  );
};

export default FlightCell;
